import { useNavigate } from 'react-router-dom';

const useLogout = () => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem('stadata-auth');
    localStorage.removeItem('stadata-token');
    localStorage.setItem("stadata-guest-session", true);
    navigate('/login');
  };
  return logout;
}

export default useLogout;
